import React from 'react';

/**
Componente divisore da utilizzare nella sezione tool di `Toolbar`.
Il divisore separa una prima sezione più importante (più interna), da una seconda meno importante.

Linee Guida: nella sezione più importante possono risiedere al massimo 2 componenti, nell'altra 4.
 */
export default function Divider() {
  return <div className="v2-toolbar__divider" />;
}
